// Clinical validation ranges from HCM PRD §2.6 and DRS v1.0.
// These are the single source of truth — used by the API, mobile app, and WhatsApp parser.
// Ranges are configurable per tenant in super-admin (within these global bounds).
// Nsofar compliance mode: locked to these values, cannot be widened.
export const CLINICAL_RANGES = {
    bp_systolic: {
        min: 60,
        max: 220,
        unit: "mmHg",
        rejectionMessage: (v) => `Systolic BP of ${v} is outside the valid range (60–220 mmHg). Please recheck and re-enter.`,
    },
    bp_diastolic: {
        min: 40,
        max: 130,
        unit: "mmHg",
        rejectionMessage: (v) => `Diastolic BP of ${v} is outside the valid range (40–130 mmHg).`,
    },
    heart_rate: {
        min: 30,
        max: 200,
        unit: "bpm",
        rejectionMessage: (v) => `Heart rate of ${v} bpm is outside the valid range (30–200 bpm).`,
    },
    spo2_percent: {
        min: 70,
        max: 100,
        unit: "%",
        rejectionMessage: (v) => `SpO2 of ${v}% is outside the valid range (70–100%).`,
    },
    temperature_celsius: {
        min: 33.0,
        max: 42.0,
        unit: "°C",
        rejectionMessage: (v) => `Temperature of ${v}°C is outside the valid range (33–42°C).`,
    },
    blood_glucose_mmol: {
        min: 1.0,
        max: 33.0,
        unit: "mmol/L",
        rejectionMessage: (v) => `Blood glucose of ${v} mmol/L is outside the valid range (1–33 mmol/L).`,
    },
    weight_kg: {
        min: 20.0,
        max: 250.0,
        unit: "kg",
        rejectionMessage: (v) => `Weight of ${v} kg is outside the valid range (20–250 kg).`,
    },
    respiratory_rate: {
        min: 6,
        max: 60,
        unit: "breaths/min",
        rejectionMessage: (v) => `Respiratory rate of ${v} is outside the valid range (6–60).`,
    },
    pain_severity: {
        min: 1,
        max: 10,
        unit: "scale",
        rejectionMessage: (v) => `Pain severity of ${v} is outside the valid range (1–10).`,
    },
};
//# sourceMappingURL=clinical-ranges.js.map